import './style.scss';
import { Link } from "react-router-dom";

function App() {
  return (
    <footer className="mc-footer">
      <section className="mc-footer__sect">
        <section className="row links-wrap">
         <div className="social-wrap dummy">
            <a className="social"
              href="/the-film">
              <span className="main">MAGNA CARTA</span> 
              <span className="sub">&nbsp; the movie</span>
            </a>          
          </div>
          <div className="social-wrap insta">
            <a className="social"
              href="https://www.instagram.com/romanticus_films"
              target="_blank">
              <span><i className="fa fa-instagram" aria-hidden="true"></i></span>&nbsp;
              romanticus_films
            </a>          
          </div>
          <div className="social-wrap youtube">
            <a className="social"
              href="https://www.youtube.com/@romanticus_productions"
              target="_blank">
              <span><i className="fa fa-youtube-play" aria-hidden="true"></i></span>&nbsp;
              Romanticus
            </a>          
          </div>
          <div className="social-wrap contact">
            <a className="social"
              href="mailto:romanticus.productions@gmail.com"
              target="_blank">
              <span><i className="fa fa-envelope" aria-hidden="true"></i></span>&nbsp;
              Email
            </a>          
          </div>         
        </section> 
        <section className="row end">
          <div className="prod-wrap">
            <div className="container">
              <div className="prod">
                <div className="logo-wrap"><img src="/images/prod-logo.png" /></div>
                <p className="name">ROMANTICUS</p>
              </div>
              <div className="rights">
                © 2026 ROMANTICUS.  ALL RIGHTS RESERVED.
              </div>            
            </div>                    
          </div> 
        </section>       
      </section>    
    </footer>
  );
}

export default App;
